import { render, staticRenderFns } from "./TriangleRewardsCard.vue?vue&type=template&id=c152a45e&scoped=true&"
import script from "./TriangleRewardsCard.vue?vue&type=script&lang=js&"
export * from "./TriangleRewardsCard.vue?vue&type=script&lang=js&"
import style0 from "./TriangleRewardsCard.vue?vue&type=style&index=0&id=c152a45e&lang=scss&scoped=true&"
import style1 from "./TriangleRewardsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c152a45e",
  null
  
)

export default component.exports